import gql from 'graphql-tag'
export default gql`
  mutation createOrganisation($token: String!, $name: String!) {
    createOrganisation(token: $token, name: $name) {
      id
    }
  }
`
